import { DragDropContext } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

let context;

function DNDHTMLBackend(DecoratedClass) {
  if (context) {
    return context(DecoratedClass);
  }
  context = DragDropContext(HTML5Backend);
  return context(DecoratedClass);
}

export { DNDHTMLBackend };